// extracted by mini-css-extract-plugin
module.exports = {"postFooter":"PostFooter-module--post-footer--Eu6pX","previousTitle":"PostFooter-module--previous-title--tIFvm","nextTitle":"PostFooter-module--next-title--1ixvR"};